<template>
  <div class="indexcontainer main-container">
      <div class="carouse hidden-sm-and-down">
        <el-carousel :interval="5000" arrow="always" :height="bannerHeight+'px'">
            <el-carousel-item v-for="(item,index) in myslide.pc" :key="index" name="index">
                <el-row :gutter="12">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <div class="bannerlogo">
                        <img ref="bannerHeight" :src="imgsrc + item.cover" alt="" @load="imgLoad" style="width: 100%"> 
                          <div v-if="myslide.huodong && index==0" class="box">
                            <img class="shuzi hour" :src="myslide.time[toDou(hour)[0]]" alt="">
                            <img class="shuzi hour" :src="myslide.time[toDou(hour)[1]]" alt="">
                            <img class="dian" :src="myslide.time[10]" alt="">
                            <img class="shuzi minutes" :src="myslide.time[toDou(minutes)[0]]" alt="">
                            <img class="shuzi minutes" :src="myslide.time[toDou(minutes)[1]]" alt="">
                            <img class="dian" :src="myslide.time[11]" alt="">
                            <img class="shuzi seconds" :src="myslide.time[toDou(seconds)[0]]" alt="">
                            <img class="shuzi seconds" :src="myslide.time[toDou(seconds)[1]]" alt="">
                            <img class="dian" :src="myslide.time[12]" alt="">
                          </div>
                      </div>
                    </el-col>
                </el-row>
            </el-carousel-item>
        </el-carousel>
        <div class="slicesimg">
           <img src="../../static/slices1.png" alt="">  
        </div>
      </div>
      <div class="content hidden-sm-and-down"   v-for="(item, index) in productlist" :key="index">
        <div ref="contentimg">
          <img class="contentimg" ref='imgx' src="../../static/secllie2.png" alt="">
        </div>
        <div class="heroBanner"  :style="{background:'url('+ imgsrc + item.series_pic+')','background-repeat':'no-repeat','background-size':'100%' }">
           <div class="series_title_pic" ref="series_title_pic">
             <router-link :to="{ name:'Product_List', query: {id: item.classify_id} }">
              <img :src="imgsrc + item.series_title_pic" alt="">
            </router-link>
            </div>
          <div class="productbox" ref="productbox">
              <div class="slider__left">
                <img :src="imgsrc + item.series_product_bg" alt="">
                <div class="seriselist">
                  <img :src="imgsrc + item.cover" alt=""/>
                  <p ref="detail">{{ item.detail }}</p>
                  <span ref="proname">
                    <router-link :to="{ name:'Product', query: {id: item.id} }"> {{ item.name }}> </router-link>
                  </span>
                </div>
              </div>
              <div class="slider__rig">
                <swiper :options="swiperOption" ref="mySwiper">
                  <swiper-slide
                    class="shoplist"
                    v-for="(items, index) in item.list"
                    :key="index"
                  >
                    <div class="slidimg">
                      <img :src="imgsrc + items.cover" alt=""/>
                    </div>
                    <p>{{ items.name }}</p>
                    <span  class="prductname">
                      <router-link :to="{ name:'Product', query: {id: items.id} }" > 查看产品></router-link>
                    </span>
                  </swiper-slide>
                  <div ref="scrollbar" class="swiper-scrollbar" slot="scrollbar"></div>
                </swiper>
              </div>
          </div>
          <div ref="shopbox" class="shopbox">
             <div ref="shopimg">
              <img class="shopimg" src="../../static/secllie2.png" alt="">
            </div>
           <div class="shopbt">
              <el-row :gutter="20">
              <el-col :span="4-6"><div class="grid-content bg-purple"><a target="_blank" href="https://liuyanniangzhi.tmall.com/shop/view_shop.htm?spm=a220m.1000862.1000730.2.99114cb5FuwAPa&user_number_id=2212408218113&rn=3360f8e58e1e8a3539bd0ff5c27d6d10"><img src="../assets/tb.png" alt=""></a></div></el-col>
              <el-col :span="4-6"><div class="grid-content bg-purple"><a target="_blank" href="https://mall.jd.com/index-10094074.html"><img src="../assets/jd.png" alt=""></a></div></el-col>
              <el-col :span="4-6">
                <div class="grid-content bg-purple">
                  <el-dropdown>
                    <el-button type="primary">
                    <img src="../assets/yz.png" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <img style="max-width:200px;" src="../assets/yzewm.jpg" alt="">
                    </el-dropdown-menu>
                  </el-dropdown>
                  </div>
                </el-col>
                <el-col :span="4-6"><div class="grid-content bg-purple"><a target="_blank" href="https://mobile.yangkeduo.com/mall_page.html?mall_id=680745530&ts=1657705446911&has_decoration=1&msn=njdrveucontdq6qsbctwlptcpi_axbuy&refer_share_id=8c74d81ec44a4cb3ac7f97852cb5c8f7&refer_share_uin=APHESBWSU72XMDX6CGGZ4RCBR4_GEXDA&refer_share_channel=message&refer_share_form=card"><img src="../assets/pdd2.png" alt=""></a></div></el-col>
                <el-col :span="4-6"><div class="grid-content bg-purple"><a href="https://shop485930965.taobao.com/" target="_blank"><img src="../assets/tb2.png" alt=""></a></div></el-col>
            </el-row>
           </div>
          </div>
        </div>
    </div>
  <!-- 手机端显示 -->
    <div class="hidden-md-and-up mobile">
       <div class="lbt">
          <el-carousel :interval="5000" arrow="always" :height="mobbannerHeight+'px'">
            <el-carousel-item v-for="(item,index) in myslide.mob" :key="index" name="index">
                      <div class="bannerlogo">
                        <img ref="mobbannerHeight" :src="imgsrc + item.cover" alt="" @load="imgLoad" style="width: 100%"> 
                      </div>
            </el-carousel-item>
        </el-carousel>
        <div class="geduan">
          <img src="../../static/mobile/lbt.png" alt="">
        </div>
       </div>
       <div class="mobproduct">
          <div class="mobnewproduct">
            <div class="mobimg" v-for="(item,index) in homelist" :key="index">
               <router-link  :to=" item.is_product == 1 ? {  name:'Product', query: {id: item.product_id} } : {  name:'Product_List', query: {id: item.classify_id} } ">
                 <img  :src="imgsrc +item.h5_list_pic" alt="">
              </router-link>
            </div>
          </div>
          <div class="productitle">
              <img src="../../static/mobile/protitle.png" alt="">
          </div>
          <div class="productlist">
            <el-row :gutter="20">
              <el-col :span="12" v-for="(item, index) in prolist" :key="index">
                <div class="grid-content bg-purple" @click="sklehandle(item.classify_id)">
                  <img :src="imgsrc + item.nav_product_img" alt="">
                  <router-link :to="{ name:'Product_List', query: {id: item.classify_id} }">
                      {{ item.product_classify }}系列
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </div>
       </div>
    </div>
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { product_detailsAPI,GetHomeAPI,carousel_url,GetNavAPI,homelist_url,h5_home_classify} from "@/request/api.js";
export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      },
      productlist: [],
      prolist:[],
      homelist:[],
      myslide: {
              pc: [],
              mob: [],
              time: [
                 'https://www.fngzgw.com/Public/Home/images/0-min.png',
                  'https://www.fngzgw.com/Public/Home/images/1-min.png',
                  'https://www.fngzgw.com/Public/Home/images/2-min.png',
                  'https://www.fngzgw.com/Public/Home/images/3-min.png',
                  'https://www.fngzgw.com/Public/Home/images/4-min.png',
                  'https://www.fngzgw.com/Public/Home/images/5-min.png',
                  'https://www.fngzgw.com/Public/Home/images/6-min.png',
                  'https://www.fngzgw.com/Public/Home/images/7-min.png',
                  'https://www.fngzgw.com/Public/Home/images/8-min.png',
                  'https://www.fngzgw.com/Public/Home/images/9-min.png',
                  'https://www.fngzgw.com/Public/Home/images/h.png',
                  'https://www.fngzgw.com/Public/Home/images/m.png',
                  'https://www.fngzgw.com/Public/Home/images/s.png',
              ],
              yure_time: 1633916647,//秒
              start_time: 1633916647,//秒
              end_time: 1630339200,//秒
              now_time: 0,
              huodong: true
          },
          myslideH: 'auto',
          imgUrl: "",
          bannerHeight:"",
          mobbannerHeight:'',
          msg:''
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper;
    },
  },
  methods: {
    sklehandle(id){
      this.$router.push({path:'/Product_List',query:{id:id}})
    },
    imgLoad(){
        this.$nextTick(()=>{
          if(this.$refs.bannerHeight){
            this.bannerHeight=this.$refs.bannerHeight[0].height;
          }
         
        })
          this.$nextTick(()=>{
          if(this.$refs.mobbannerHeight){
            this.mobbannerHeight=this.$refs.mobbannerHeight[0].height;
          }
         
        })
    },
        toDou(n) {
        if (n < 10) {
          return '0' + n;//建立函数，做一个判断，如果这个数字小于10，那他就是个单数，就需要给他补一个0返回出去
        }
        return '' + n;
      }, //返回n；
      //倒计时
      huodongF() {
        var that = this

        function daojishi() {
          that.myslide.now_time = parseInt(Number(new Date()) / 1000);//暂时获取本地时间,最好从后台获取网络时间防止本地时间不对
          if (that.myslide.now_time < that.myslide.yure_time) {
            console.log('活动还没开始')
            that.myslide.huodong = false;
          } else if (that.myslide.now_time >= that.myslide.yure_time && that.myslide.now_time < that.myslide.start_time) {
            console.log('活动预热')
            that.myslide.huodong = true;
            that.hour = parseInt((that.myslide.start_time - that.myslide.now_time) / (60 * 60)),
                that.minutes = parseInt((that.myslide.start_time - that.myslide.now_time) / 60) - that.hour * 60,
                that.seconds = parseInt(that.myslide.start_time - that.myslide.now_time) - that.hour * 60 * 60 - that.minutes * 60;
          } else if (that.myslide.now_time >= that.myslide.start_time && that.myslide.now_time <= that.myslide.end_time) {
            console.log('活动开始')
            that.myslide.huodong = true;
            that.hour = parseInt((that.myslide.end_time - that.myslide.now_time) / (60 * 60)),
                that.minutes = parseInt((that.myslide.end_time - that.myslide.now_time) / 60) - that.hour * 60,
                that.seconds = parseInt(that.myslide.end_time - that.myslide.now_time) - that.hour * 60 * 60 - that.minutes * 60;
          } else if (that.myslide.now_time > that.myslide.end_time) {
            console.log('活动结束了啊')

            //活动结束后重新请求轮播图
            that.getImgUrl()

            that.myslide.huodong = false;
            clearInterval(that.timer);
            that.timer = ''
          }
        }

        daojishi();
        that.timer = setInterval(function () {
          daojishi()
        }, 1000);
      },
    // pc轮播图
    getImgUrl(){
      carousel_url({posters_cate_id: 1}).then((res)=>{
        this.myslide.pc = res.data.data
      })
       carousel_url({posters_cate_id: 3}).then((res)=>{
        this.myslide.mob = res.data.data
      })
    },
  },
  updated (){
    if(this.$refs.shopbox){
        this.$refs.shopbox[0].style.display = 'none'
    }
    if(this.$refs.contentimg){
      this.$refs.imgx[1].style.top = '-3.9%'
    }
    if(this.$refs.detail){
      if(this.$refs.detail.length %2==0){
      }else{
       this.$refs.proname[1].firstChild.style.color = '#fff'
       this.$refs.proname[1].firstChild.style.borderBottom = '1px solid #fff'
       this.$refs.detail[1].style.color = '#fff'
      }
    }
    if(this.$refs.scrollbar){

      document.getElementsByClassName("swiper-scrollbar-drag")[1].style.background = 'rgb(255, 255, 255)'
    
    }
    // console.log(this.$refs.productbox)
    // if(this.$refs.productbox){
    //   this.$refs.productbox[2].style.marginBottom = '2%'
    // }
    // if(this.$refs.series_title_pic){
    //   this.$refs.series_title_pic[2].style.top = '13.5%'
    // }
       window.addEventListener('resize',() => {
             if(this.$refs.bannerHeight){
              this.bannerHeight=this.$refs.bannerHeight[0].height;
             }
              this.imgLoad();
            },false)
  },
  mounted() {
    homelist_url().then((res)=>{
      this.homelist = res.data.data
    })
    // 手机端产品分类
    h5_home_classify().then((res)=>{
      this.prolist = res.data.data
    })

      if (this.myslide.huodong) {
        this.huodongF();
      }
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log("this is current swiper instance object", this.swiper);

    // product_detailsAPI().then((res) => {
    //   this.productlist = res.data.data;
    // });
        this.imgLoad();
            window.addEventListener('resize',() => {
                this.bannerHeight=this.$refs.bannerHeight[0].height;
                this.imgLoad();
            },false)
              window.addEventListener('resize',() => {
                this.mobbannerHeight=this.$refs.mobbannerHeight[0].height;
                this.imgLoad();
            },false)
  },
  created(){
    this.getImgUrl()
      GetHomeAPI().then((res)=>{
      this.productlist = res.data.data
    })
    
  }
};
</script>

<style lang="less" scoped>
/deep/.el-button--primary{
  background: unset;
  border: unset;
  padding: unset;
}
.indexcontainer{
  .content{
    position: relative;
    
    .contentimg{
      width: 100%;
      position: absolute;
      left: 0;
      top: -4%;
      z-index: 6;
    }
  }
  .carouse{
    width: 100%;
    position: relative;
  }
  .slicesimg{
    width: 100%;
    position: absolute;
    left: 0;
    bottom: -13%;
    z-index: 123;
    img{
      width: 100%;
    }
    }
  .heroBanner{
    width: 100%;
    overflow: hidden;
    .shopbox{
      .el-col--2{
        width: 20%;
      }
      width: 100%;
      .shopimg{
        width: 100%;
        img{
          width: 100%;
        }
      }
      .shopbt{
        width: 20%;
        min-width: 300px;
        margin: 1% auto;
        // margin-left: auto;
        // margin-right:auto;
        // margin-top: 1%;
        // margin-bottom: 2%;
        img{
          width: 38px;
        }
      }
    }
    .series_title_pic{
      width: 28%;
      position: absolute;
      top: 15%;
      left: 39%;
      img{
        width: 100%;
        height: auto;
      }
    }
    .productbox{
      width: 100%;
      overflow: hidden;
      margin-top: 23%;
      margin-bottom: 7%;
    }
    .slider__left{
      width: 30%;
      margin-left:12%;
      float: left;
      position: relative;
      .seriselist{
        position: absolute;
        width: 100%;
        top: 14%;
        left: 0;
        color: #F9E6C5;
        p{
          text-align: center;
          font-size: 25px;
          margin-top: 9%;
          font-family: "SimSun"
        }
        span{
          display: inline-block;
          margin-top: 1.5%;
         
          a{
            color: #F9E6C5;
            font-size: 16px;
             border-bottom: 1px solid #F9E6C5;
              padding-bottom: 2%;
              display: inline-block;
          }
        }
        img{
          width: 65%;
        }
      }
      img{
        width: 100%;
      }
    }
    .slider__rig{
      margin-top: 2%;
      .shoplist:hover {
          border-radius: 10px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
          background: url('../../static/productbj.png') no-repeat;
          background-size: 100% 100%;
          color: #F9E6C5;
        }
        .shoplist:hover a{
          color: #F9E6C5;
        }
      .shoplist{
        width: 25%!important;
        margin-bottom:5%;
        color: #316768 ;
        padding-bottom: 15%;
        position: relative;
        .prductseries_name{
          display: inline-block;
          margin-top: 9%;
          font-weight: 600;
        }
        .prductname{
          display: inline-block;
          margin-bottom: 23%;
          position: absolute;
          left: 50%;
          bottom: 8%; 
          transform: translate(-50%); 
          a{
            font-weight: bold;
          }   
        }
        p{
          line-height:22px;
          max-width: 160px;
          margin: 0 auto;
          padding-top: 20%;
          min-height: 42px;
          margin-bottom: 5%;
        }
        .slidimg{
          width: 100%;
          margin-top: 45%;
           img{
          width:80%;
          height: auto;
        }
        }
       
      }
      width: 50%;
      float: right;
       color: #316768 ;
       span{
         font-size: 14px;
         a{
          font-size: 14px;
          color: #316768 ;
         }
       }
       p{
         font-size: 16px;
   
       }
       
    }
  }
}
/deep/.swiper-container-horizontal > .swiper-scrollbar{
  width: 64%;
  background: #000;
}
/deep/.swiper-scrollbar-drag{
  background: #EAC184;
}
@media (max-width: 991px) {
  /deep/.el-carousel__indicators--horizontal{
    display: none;
  }
  /deep/.el-carousel__arrow{
    display: none;
  }
  .mobile{
    .lbt{
      position: relative;
    }
    .geduan{
      width: 100%;
      position: absolute;
      bottom: -0.04rem;
      z-index: 10;
      img{
        width: 100%;
      }
    }
   .mobproduct{
     background: #e6e9e7;
     width: 100%;
     .mobnewproduct{
       padding-top: 0.7rem;
       padding-bottom: 0.25rem;
       .mobimg{
        //  margin: 0.7rem 0.2rem;
        margin-bottom: 0.2rem;
        margin-left: 0.2rem;
        margin-right: 0.2rem;
            img{
              width: 100%;
            }
       }
    
     }
     .productitle{
       width: 100%;
      padding-bottom: 0.6rem;
       img{
         width: 100%;
       }
     }
     .productlist{
       margin: 0 0.3rem;
       img{
         width:100%;
         height: 2.2rem;
       }
       a{
         display: inline-block;
         width: 2.03rem;
         height: 0.43rem;
         background: url(../../static/mobile/productbtn.png) no-repeat;
         background-size:2.03rem 0.43rem;
          font-size: 0.33rem;
          line-height: 0.43rem;
          text-shadow: -2px 1px 2px rgba(0, 26, 30, 0.2);
          color: #E0FFFE;
          margin: 0.2rem 0 0.3rem 0;
       }
       .probtn{
         width: 2.03rem;
         margin: 0.2rem 0 0.3rem 0;
        
       }
     }
   }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/index.vue